<template>
  <div
    class="chuangguan"
    :class="ifMobile ? 'mobile' : 'comp'"
  >
    <div
      class="index"
      @scroll="handleScroll"
      ref="scrollObj"
    >
      <div
        class="loading"
        v-if="loading"
      >
        <img
          src="./img/loading.gif"
          alt=""
        >
        <div>LOADING~</div>
      </div>
      <div
        class="main"
        style="padding-bottom: 240px"
      >
        <div
          v-if="allLesson[0]"
          :style="`height:${screenHeight}px`"
          :class="`lesson-wrap`"
        >
          <!-- <div class="lesson-title">{{ allLesson[0].step }}</div> -->
          <template v-for="(lesson, idx) in allLesson">
            <div
              class="step-title"
              :style="`bottom:${(stepMap[lesson.step].index*150)+190+(stepMap[lesson.step].total!==stepMap[lesson.step].cur?0:15)+commonPos[idx][ifMobile ? 'bottomMobile' : 'bottom']}px;`"
              :key="lesson._id"
              v-if="titleMap[lesson.lesson_id]"
            >
              <div
                class="step-side-title"
                v-if="stepMap[lesson.step].total!==stepMap[lesson.step].cur"
              >再完成{{stepMap[lesson.step].total-stepMap[lesson.step].cur}}节课进入下阶段</div>{{lesson.step}}（{{stepMap[lesson.step].cur}}/{{stepMap[lesson.step].total}}）
            </div>
            <div
              v-if="lesson.stars < 3"
              :ref="idx===allLesson.length-1?'lastLesson':lesson.lesson_id===user.current_lesson_id?'curLesson':''"
              class="lesson-item"
              @click="getDetail(lesson.lesson_id)"
              :key="idx"
              :style="`bottom:${(stepMap[lesson.step].index*150)+commonPos[idx][ifMobile ? 'bottomMobile' : 'bottom']}px;left:${
                commonPos[idx][ifMobile ? 'leftMobile' : 'left']
              };${commonPos[idx][ifMobile ? 'leftMobile' : 'left']==='100%'?'margin-left:-233px':''}`"
            >
              <div
                class="lesson-name"
                :class="lesson.stars>0?'finish-lesson-name':''"
              >{{ lesson.lesson_name }}</div>
              <div class="lesson-star">
                <div
                  class="dialog-star"
                  :class="lesson.stars >= star?'finish':'unfinish'"
                  v-for="star in [1, 2, 3]"
                  :key="star"
                >
                  ★
                </div>
              </div>
              <div class="lesston-goto-btn">去闯关</div>
            </div>
            <div
              v-else
              class="finish-lesson-item"
              :ref="idx===allLesson.length-1?'lastLesson':lesson.lesson_id===user.current_lesson_id?'curLesson':''"
              @click="getDetail(lesson.lesson_id)"
              :key="idx"
              :style="`bottom:${(stepMap[lesson.step].index*150)+commonPos[idx][ifMobile ? 'bottomMobile' : 'bottom']}px;left:${
                commonPos[idx][ifMobile ? 'leftMobile' : 'left']
              };${commonPos[idx][ifMobile ? 'leftMobile' : 'left']==='100%'?'margin-left:-233px':''}`"
            >
              <div class="lesson-name finish-lesson-name">{{ lesson.lesson_name }}</div>
              <div class="lesson-star">
                <div class="dialog-star">★</div>
                <div class="dialog-star">★</div>
                <div class="dialog-star">★</div>
              </div>
              <div class="lesston-goto-btn">完美达成</div>
            </div>
          </template>
        </div>
        <!-- <template v-for="item in finishedLevel">
          <div
            v-if="finishedLevelList[item][0]"
            :style="`height:${(finishedLevelList[item].length - 1) * 140}px`"
            :class="`lesson-wrap ${finishedLevelList[item][0].step === '新手村' ? 'initial-lesson' : ''}`"
            :key="item"
          >
            <template v-for="(lesson, idx) in finishedLevelList[item]">
              <div
                v-if="lesson.stars < 3"
                class="lesson-item"
                @click="getDetail(lesson.lesson_id)"
                :key="idx"
                :style="`bottom:${commonPos[idx][ifMobile ? 'bottomMobile' : 'bottom']}px;left:${
                  commonPos[idx][ifMobile ? 'leftMobile' : 'left']
                }px`"
              >
                <div class="lesson-name">{{ lesson.lesson_name }}</div>
                <div class="lesson-star">
                  <div class="dialog-star" v-for="star in [1, 2, 3]" :key="star">
                    {{ lesson.stars >= star ? '★' : '☆' }}
                  </div>
                </div>
                <div class="lesston-goto-btn">去刷分</div>
              </div>
              <div
                v-else
                class="lesson-item"
                @click="getDetail(lesson.lesson_id)"
                :key="idx"
                :style="`bottom:${commonPos[idx][ifMobile ? 'bottomMobile' : 'bottom']}px;left:${
                  commonPos[idx][ifMobile ? 'leftMobile' : 'left']
                }px`"
              >
                <div class="lesson-name">{{ lesson.lesson_name }}</div>
                <div class="lesson-star">
                  <div class="dialog-star finish">★</div>
                  <div class="dialog-star finish">★</div>
                  <div class="dialog-star finish">★</div>
                </div>
                <div class="lesston-goto-btn">去刷分</div>
              </div>
            </template>
          </div>
        </template> -->
      </div>
    </div>
    <div class="qifei">
      <img
        src="./img/qifei.png"
        alt=""
      />
    </div>
    <div
      class="lesson-dialog"
      v-if="showDialog && curLesson"
    >
      <div class="lesson-dialog-wrap">
        <div
          class="close-dialog"
          @click="closeDialog"
        >×</div>
        <div class="dialog-header">
          <div class="dialog-header-img">
            <img
              :style="`height:${bgSizeDialog[curLesson.stars]}px;width:${bgSizeDialog[curLesson.stars]}px`"
              v-if="!curLesson.stars"
              :src="imgs.img0"
              alt=""
            />
            <img
              :style="`height:${bgSizeDialog[curLesson.stars]}px;width:${bgSizeDialog[curLesson.stars]}px`"
              v-else
              :src="imgs[`img${curLesson.stars}_${curLesson.randomNum}`]"
              alt=""
            />
          </div>
          <div class="dialog-header-info">
            <span class="dialog-heade-name">{{ curLesson.课程名称 }}</span>
          </div>
        </div>
        <div class="dialog-star-wrap">
          <div
            class="dialog-star"
            v-for="star in [1, 2, 3]"
            :class="curLesson.stars >= star ? 'finish' : 'unfinish'"
            :key="star"
          >
            ★
          </div>
        </div>
        <div class="dialog-content">
          <div class="content-desc">{{ curLesson.课程简介 }}</div>
          <div class="dialog-tasks-wrap">
            <div class="dialig-tips">（带<b>*</b>号任务为手动点亮，在达到要求后可以联系福星小姐姐哦）</div>
            <div
              class="dialog-task-item"
              :class="item.every((y) => y.finished) ? 'finish-item' : 'unfinish-item'"
              v-for="(item, idx) in curLesson.tasks"
              :key="idx"
            >
              <div
                class="dialog-star"
                v-if="idx==='star1'"
                :class="`star-num-${idx}`"
                style="margin-right: 15px"
              >
                ★
              </div>
              <div
                class="dialog-star"
                v-if="idx==='star2'"
                :class="`star-num-${idx}`"
                style="margin-right: 15px"
              >
                ★★
              </div>
              <div
                class="dialog-star"
                v-if="idx==='star3'"
                :class="`star-num-${idx}`"
                style="margin-right: 15px"
              > ★
                ★★
              </div>
              <div class="dialog-name-wrap">
                <div
                  class="dialog-name"
                  v-for="(task, tidx) in item"
                  :key="tidx"
                >
                  <span>{{ task.name }}（{{task.finished?'1':'0'}}/1）<b v-if="task.hand">*</b></span>

                  <!-- <span
                    v-if="task.finish_time"
                    style="flex-shrink: 0"
                  >{{ task.finish_time | formatdate }}达成</span> -->
                </div>
              </div>
              <!-- <div
                class="dialog-name-gotobtn"
                v-if="!item.every((y) => y.finished)"
                @click="toUrl(curLesson.课程链接,curLesson,idx)"
              >去完成</div> -->
              <div
                class="dialog-item-stamp"
                v-if="item.every((y) => y.finished)"
              ><img
                  src="./img/complete.png"
                  alt=""
                ></div>
            </div>
          </div>
        </div>
        <div
          class="dialog-button"
          @click="toUrl(curLesson.课程链接, curLesson)"
        >
          {{ curLesson.stars === 3 ? '你真棒！已完成技能成就' : '去完成课程' }}
        </div>
      </div>
    </div>
    <!-- <div class="menu" :class="menuHidden ? 'menu-hidden' : ''">
      <div class="menu-bg">
        <div class="menu-title">技能树通关档案</div>
        <div class="menu-wrap">
          <div class="menu-item">
            <div class="menu-name">姓名：</div>
            <div class="menu-value">{{ user.name }}</div>
          </div>
          <div class="menu-item" v-if="user.stars || user.stars === 0">
            <div class="menu-name">段位：</div>
            <div class="menu-value" style="cursor: pointer" :title="rank.desc">
              <div class="square" :style="`background-color:${rank.color}`"></div>
              <span>{{ rank.name }}</span>
            </div>
          </div>
          <div class="menu-item">
            <div class="menu-name">开始时间：</div>
            <div class="menu-value">2021.6（6个月）</div>
          </div>
          <div class="menu-item" v-if="user.stars || user.stars === 0">
            <div class="menu-name">星级：</div>
            <div class="menu-value">
              <i class="el-icon-star-on"></i><span>{{ user.stars }}星</span
              ><span style="font-size: 12px">（升级还差{{ 20 - (user.stars % 20) }}星）</span>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
const img0 = require('./img/0.png')
const img1_1 = require('./img/1-1.png')
const img1_2 = require('./img/1-2.png')
const img2_1 = require('./img/2-1.png')
const img2_2 = require('./img/2-2.png')
const img3_1 = require('./img/3-1.png')
const img3_2 = require('./img/3-2.png')
export default {
  data() {
    return {
      loading: false,
      imgs: { img1_1, img1_2, img2_1, img2_2, img0, img3_1, img3_2 },
      ifMobile: false,
      showDialog: false,
      user: {},
      curLesson: null,
      levelList: [],
      finishedLevel: [],
      finishedLevelList: [],
      allLesson: [],
      commonPos: [],
      stepMap: {
        新手村: { index: 0, total: 7, cur: 0 },
        第一阶段: { index: 1, total: 13, cur: 0 },
        第二阶段: { index: 2, total: 9, cur: 0 },
        第三阶段: { index: 3, total: 11, cur: 0 },
        第四阶段: { index: 4, total: 11, cur: 0 },
      },
      titleMap: {
        7: '第一阶段',
        20: '第二阶段',
        30: '第三阶段',
        45: '第四阶段',
      },
      screenHeight: 900,
      rankList: [
        {
          name: '半见白',
          desc: '言在黄白之间，其色半出，不全成也',
          limit: 20,
          color: '#fffbf0',
        },
        {
          name: '明天黄',
          desc: '明日中天之色',
          limit: 40,
          color: '#f7ab00',
        },
        {
          name: '麹尘青',
          desc: '冬去春来，柳出新芽之色',
          limit: 60,
          color: '#C0D09D',
        },
        {
          name: '松石绿',
          desc: '螺青点出莫山色，石绿染成春浦潮',
          limit: 80,
          color: '#256535',
        },
        {
          name: '水天碧',
          desc: '天青雨过破云之处，天降露水染碧之色',
          limit: 100,
          color: '#7EC0EE',
        },
        {
          name: '灵砂朱',
          desc: '丹砂之石，淬火研磨，盐泥固济，大火锻之，得为灵砂之色',
          limit: 120,
          color: '#CD0000',
        },
        {
          name: '紫磨金',
          desc: '金之优者，名曰紫磨，犹人之有圣也',
          limit: 140,
          color: '#CD8500',
        },
      ],
      rank: {},
      menuHidden: false,
      bgSize: {
        0: 40,
        1: 40,
        2: 50,
        3: 80,
      },
      bgSizeDialog: {
        0: 40,
        1: 40,
        2: 50,
        3: 60,
      },
      initPos: [
        {
          bottom: '620',
          left: '90',
          bottomMobile: '300',
          leftMobile: '40',
        },
        {
          bottom: '680',
          left: '360',
          bottomMobile: '360',
          leftMobile: '240',
        },
        {
          bottom: '730',
          left: '210',
          bottomMobile: '380',
          leftMobile: '140',
        },
        {
          bottom: '830',
          left: '70',
          bottomMobile: '480',
          leftMobile: '40',
        },
        {
          bottom: '880',
          left: '230',
          bottomMobile: '580',
          leftMobile: '140',
        },
        {
          bottom: '930',
          left: '390',
          bottomMobile: '600',
          leftMobile: '260',
        },
        {
          bottom: '1000',
          left: '120',
          bottomMobile: '660',
          leftMobile: '50',
        },
      ],
      scrollTimeout: null,
    }
  },
  filters: {
    formatdate: function (date) {
      const createdDate = new Date(date)
      if (!date) {
        return
      }
      return `${createdDate.getFullYear()}-${createdDate.getMonth() + 1}-${createdDate.getDate()}`
    },
  },
  methods: {
    handleScroll(e) {
      // if (!this.menuHidden) {
      //   this.menuHidden = true
      //   this.scrollTimeout = setTimeout(() => {
      //     this.menuHidden = false
      //     clearTimeout(this.scrollTimeout)
      //     this.scrollTimeout = null
      //   }, 700)
      // }
      // if (this.scrollTimeout) {
      //   clearTimeout(this.scrollTimeout)
      //   this.scrollTimeout = null
      //   this.scrollTimeout = setTimeout(() => {
      //     this.menuHidden = false
      //     clearTimeout(this.scrollTimeout)
      //     this.scrollTimeout = null
      //   }, 700)
      // }
    },
    toUrl(url, curLesson, idx) {
      if (curLesson.stars === 3) {
        return
      }
      const map = ['PEVC链接', '二级市场链接', '投行链接']
      if (!url && curLesson._id === 12) {
        for (let i = 1; i <= 3; i++) {
          if (curLesson.tasks['star' + i].every((s) => s.finished)) {
            continue
          } else {
            window.open(curLesson[map[i - 1]], '_blank')
            break
          }
        }
        return
      }
      window.open(url, '_blank')
    },
    closeDialog() {
      this.curLesson = null
      this.showDialog = false
    },
    routerTo(path) {
      this.$router.push(path)
    },
    async init() {
      if (!app.accounts) {
        await app.getUsers()
      }
      await this.getUserInfo()
      await this.getLesson()
    },
    async getDetail(lesson_id) {
      const { data } = await app
        .service('misc')
        .getLessonStarDetail({ tel: app.user.个人手机 || app.user.工作手机 || '', lesson_id })
      // if (data.tasks) {
      //   data.tasks = [data.tasks.star1, data.tasks.star2, data.tasks.star3]
      // }
      // const completeTask = []
      // data.tasks.forEach((t) => {
      //   if (t.every((y) => y.finished)) {
      //     completeTask.push(t)
      //   }
      // })
      // data.tasks = data.tasks.filter((t) => !t.every((y) => y.finished)).concat(completeTask)
      this.curLesson = data
      this.curLesson.randomNum = Math.ceil(Math.random() * 2)
      this.showDialog = true
    },
    async getUserInfo() {
      const { data } = await app.service('misc').getLessonMember({ tel: app.user.个人手机 || app.user.工作手机 || '' })
      this.user = data
      this.rank = this.rankList[Math.floor(Math.abs(this.user.stars - 1) / 20)]
    },
    async getLesson() {
      const res = await app.service('misc').getLessonLevels({ tel: app.user.个人手机 || app.user.工作手机 || '' })
      if (res.status === 'fail') {
        this.$alert(
          `<h3 style="text-align:center">${res.msg}</h3><p style="text-align:center">请添加管理员微信询问解决~</p><div><img style="margin:20px auto 0;width:200px;height:200px;" src="https://alphahr-files-backup.oss-cn-beijing.aliyuncs.com/wechat/jobHunting/common/fuxingqrcode.png" alt=""></div>`,
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            center: true,
            showClose: false,
          },
        )
        return
      }
      const data = res.data
      data.levelList &&
        data.levelList.length &&
        data.levelList.forEach((e) => (e.randomNum = Math.ceil(Math.random() * 2)))
      this.levelList = data.levelList && data.levelList.length ? data.levelList : []
      this.finishedLevel = Object.keys(data.finishedLevel)
      this.finishedLevel.forEach((e) =>
        data.finishedLevel[e].forEach((i) => (i.randomNum = Math.ceil(Math.random() * 2))),
      )
      this.finishedLevelList = data.finishedLevel
      Object.keys(this.stepMap).forEach((cname, idx) => {
        console.log(cname)
        if (this.levelList && this.levelList[0] && this.levelList[0].step === cname) {
          this.stepMap[cname].cur = this.levelList.filter((l) => l.stars > 0).length
        }
        if (this.finishedLevelList[cname]) {
          this.stepMap[cname].cur = this.finishedLevelList[cname].length
        }
      })
      let allLesson = []
      this.finishedLevel.forEach((l) => {
        allLesson = allLesson.concat(data.finishedLevel[l])
      })
      this.allLesson = allLesson.concat(data.levelList)
      console.log(this.allLesson)
      this.$nextTick(() => {
        this.screenHeight = parseInt(this.$refs.lastLesson[0].style.bottom) + 230
        this.$nextTick(() => {
          if (this.$refs.curLesson && this.$refs.curLesson[0]) {
            if (this.ifMobile) {
              window.scrollTo(0, this.$refs.curLesson[0].offsetTop - 200)
            } else {
              this.$refs.scrollObj.scrollTo(0, this.$refs.curLesson[0].offsetTop - 200)
            }
          } else {
            window.scrollTo(0, 0)
          }
        })
      })
    },
    getLessonPos() {
      const arr = []
      for (let i = 0; i <= 50; i++) {
        if (i % 2 === 0) {
          arr.push({
            left: '300px',
            bottom: 40 + 120 * i,
            leftMobile: '100%',
            bottomMobile: 10 + 120 * i,
          })
        }
        if (i % 2 === 1) {
          arr.push({
            left: '24px',
            bottom: 40 + 120 * i,
            leftMobile: '24px',
            bottomMobile: 10 + 120 * i,
          })
        }
      }
      this.commonPos = arr
    },
  },
  async mounted() {
    this.ifMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
    this.loading = true
    this.getLessonPos()
    await this.init()
    this.loading = false
  },
}
</script>
<style scoped>
.main {
  background-image: url('./img/inf-bg.png');
  background-size: 100% 100%;
  min-height: 100vh;
}
.lesson-wrap {
  width: 100%;
  /* background: linear-gradient(90deg, #a283a5 0%, #e8b7c7 29%, #e8b7c7 45%, #5e4677 100%); */
  padding: 20px 0;
  position: relative;
}
.lesson-wrap.initial-lesson {
  /* height: 1200px !important; */
  /* background-image: url('./img/main-bg.png'); */
  /* background-size: 100% 100%; */
  /* background-position-y: bottom; */
}
.menu {
  width: 500px;
  position: fixed;
  bottom: 48px;
  left: 0;
  right: 0;
  margin: 0 auto;
  background-color: rgba(255, 255, 255, 0.6);
  padding: 10px;
  border-radius: 8px;
  color: #fff;
  transition: 0.2s ease-in-out bottom;
}
.menu-hidden {
  bottom: -64px;
}
.menu-bg {
  width: 100%;
  height: 100%;
  background-color: rgb(151, 101, 143, 0.8);
  border-radius: 8px;
  padding: 15px;
}
.menu-title {
  font-size: 16px;
  font-weight: 600;
  padding: 0 0 10px 0;
}
.menu-value {
  display: flex;
  align-items: center;
  white-space: nowrap;
}
.menu-value i {
  color: #ffe000;
  display: block;
  margin-right: 5px;
  font-size: 20px;
}
.square {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  background-color: #fffc37;
  margin-right: 10px;
}
.menu-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.menu-item {
  width: 50%;
  margin-bottom: 10px;
  font-size: 14px;
  display: flex;
  align-items: center;
}
.menu-name {
  width: 30%;
  margin-right: 10px;
  flex-shrink: 0;
}
.menu-button-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.menu-button {
  background-color: rgb(90, 67, 104);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  border-radius: 8px;
  padding: 10px 20px;
  cursor: pointer;
}
.lesson-title {
  width: 100%;
  color: #fff;
  font-weight: 600;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}
/* .lesson-wrap.initial-lesson .lesson-title {
  margin-top: -30px;
} */
.lesson-title::before,
.lesson-title::after {
  content: '';
  display: block;
  width: 35%;
  border-top: 2px dashed #fff;
  margin: 0 20px;
}
.lesson-item {
  position: absolute;
  cursor: pointer;
  width: 213px;
  height: 100px;
  background-image: url('./img/normal-star.png');
  background-size: 100% 100%;
}
.dialog-star-wrap .dialog-star {
  font-size: 60px;
}
.lesson-item .no-stars {
}
.lesson-name {
  font-size: 18px;
  color: #ffffff;
  position: absolute;
  left: 76px;
  bottom: 74px;
  width: 136px;
  text-align: center;
  min-height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #00012e;
  padding: 10px;
  border-radius: 8px;
}
.finish-lesson-name {
  background-color: #06edf694;
}
.lesson-star {
  position: absolute;
  left: 33px;
  top: 33%;
  width: 73%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.finish-lesson-item {
  position: absolute;
  cursor: pointer;
  width: 200px;
  height: 100px;
  background-image: url('./img/full-star.png');
  background-size: 100% 100%;
}
.finish-lesson-item .lesson-name {
  font-size: 18px;
  color: #ffffff;
  position: absolute;
  left: 78px;
  width: 121px;
}
.finish-lesson-item .lesson-star {
  position: absolute;
  left: 87px;
  top: 32%;
  width: 49%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.lesson-star .dialog-star {
  color: #06edf6;
}
.lesston-goto-btn {
  position: absolute;
  bottom: 7px;
  left: 74px;
  font-size: 18px;
  color: #06edf6;
}
.finish-lesson-item .lesston-goto-btn {
  position: absolute;
  bottom: 7px;
  left: 97px;
  font-size: 18px;
  color: #ffffff;
}
.mobile .qifei {
  width: 102px;
  height: 145px;
  position: fixed;
  bottom: 80px;
  left: 50%;
  margin-left: -51px;
}
.qifei {
  width: 152px;
  height: 205px;
  position: fixed;
  bottom: 80px;
  left: 50%;
  margin-left: -76px;
}
.qifei img {
  width: 100%;
  height: 100%;
  display: block;
}
.lesson-dialog {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;
}
.lesson-dialog-wrap {
  width: 450px;
  min-height: 75vh;
  padding: 30px;
  background-color: rgb(0, 85, 120);
  border-radius: 16px;
  position: relative;
  padding-bottom: 90px !important;
}
.dialog-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.dialog-header-img {
  width: 60px;
  height: 60px;
  margin-right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dialog-header-info {
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 10px;
}
.dialog-heade-name {
  margin-bottom: 10px;
  display: block;
}
.dialog-star-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 60px;
  user-select: none;
  margin-bottom: 30px;
}
.dialog-star {
  font-size: 30px;
  line-height: 30px;
  margin: 0 3px;
  flex-shrink: 0;
}
.get-star.dialog-star {
  font-size: 36px;
  position: relative;
}
.star-num-star1 {
  font-size: 34px;
  width: 30px;
  text-align: center;
}
.star-num-star2 {
  font-size: 28px;
  text-align: center;
  width: 30px;
  letter-spacing: -8px;
}
.star-num-star3 {
  font-size: 20px;
  text-align: center;
  width: 30px;
  line-height: 16px;
}
.mobile .step-title {
  font-size: 16px;
}
.step-title {
  position: absolute;
  left: 0;
  color: #fff;
  width: 100%;
  color: #fff;
  font-weight: 600;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  white-space: nowrap;
}
.step-side-title {
  position: absolute;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #999;
  left: 0;
  bottom: -28px;
}
.step-title::before,
.step-title::after {
  content: '';
  display: block;
  width: 30%;
  border-top: 2px dashed #fff;
  margin: 0 20px;
}
.content-desc {
  font-size: 14px;
  margin-bottom: 40px;
  color: #fff;
  text-align: justify;
  max-height: 230px;
  overflow-y: auto;
  text-indent: 2em;
  line-height: 1.5;
}
.dialog-task-item {
  display: flex;
  margin-bottom: 10px;
  align-items: center;
  border: 2px solid #06edf6;
  padding: 15px 10px;
  /* border-image: linear-gradient(90deg, #e4035d, #38adfd) 10 10; */
  position: relative;
}
.dialog-task-item.finish-item {
  border: 2px solid #06edf6;
  border-image: none;
}
.dialog-name-wrap {
  flex-grow: 1;
  margin-right: 10px;
}
.dialog-name {
  font-size: 14px;
  color: #fff;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.dialog-name b {
  font-size: 26px;
  color: red;
  vertical-align: middle;
  line-height: 0;
}
.dialog-name-gotobtn {
  justify-content: center;
  border-radius: 8px;
  width: 60px;
  height: 30px;
  display: flex;
  align-items: center;
  color: #fff;
  cursor: pointer;
  flex-shrink: 0;
  /* background: rgb(71, 157, 238); */
  background: linear-gradient(90deg, #e4035d 0%, #38adfd 100%);
}
.dialog-item-stamp {
  width: 50px;
  height: 50px;
  position: absolute;
  right: 15px;
  flex-shrink: 0;
}
.dialog-item-stamp img {
  width: 100%;
  height: 100%;
  display: block;
}
.dialog-button {
  position: absolute;
  width: 300px;
  height: 60px;
  left: 50%;
  margin-left: -150px;
  bottom: 40px;
  color: rgb(203, 253, 255);
  border-radius: 16px;
  background-color: rgb(71, 157, 238);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  cursor: pointer;
}
.close-dialog {
  position: absolute;
  right: 20px;
  top: 20px;
  font-size: 20px;
  color: #fff;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.dialog-star span {
  font-size: 24px;
}
.dialog-star.finish,
.dialog-task-item.finish-item .dialog-star {
  color: #06edf6;
}
.dialog-star.unfinish,
.dialog-task-item.unfinish-item .dialog-star {
  color: #06edf64f;
}
.loading {
  height: calc(100vh - 60px);
  width: 550px;
  background-image: url('https://alphahr-files-backup.oss-cn-beijing.aliyuncs.com/wechat/jobHunting/newChuangguan/bg.png');
  background-position-y: bottom;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
}
.loading img {
  width: 160px;
  height: 160px;
  display: block;
  margin-bottom: 20px;
}
.loading div {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 36px;
  padding: 0 60px;
  color: #fff;
}

.mobile .lesson-name {
  font-size: 14px;
  padding: 5px;
}
.mobile .lesson-wrap {
  padding: 0;
  padding-top: 15px;
}
.mobile .lesson-title::before,
.mobile .lesson-title::after {
  width: 30%;
}
.mobile .lesson-wrap.initial-lesson {
  /* height: 860px !important; */
}
.mobile .lesson-dialog-wrap {
  width: 330px;
  padding: 15px;
  min-height: 65vh;
}
.mobile .dialog-header-img {
  width: 60px;
  height: 60px;
}
.mobile .dialog-header-info {
  font-size: 16px;
}
.mobile .dialog-star {
  font-size: 24px;
}
.mobile .dialog-star-wrap .dialog-star {
  font-size: 44px;
}
.mobile .dialog-header {
  margin-bottom: 15px;
}
.mobile .content-desc {
  font-size: 14px;
  margin-bottom: 20px;
  max-height: 100px;
}
.mobile .dialog-button {
  bottom: 20px;
}
.mobile .close-dialog {
  right: 15px;
  top: 15px;
}
.mobile .menu {
  padding: 8px;
  width: 90vw;
}
.mobile .menu-bg {
  padding: 10px;
}
.mobile .menu-value {
  white-space: normal;
}
.mobile .menu-wrap {
  margin-bottom: 25px;
}
.mobile .loading {
  width: 100vw;
  height: 100vh;
}
.mobile .loading div {
  font-size: 30px;
  padding: 0 40px;
}
.mobile .tab {
  width: 100vw;
}
.tab {
  width: 550px;
  height: 40px;
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  background-color: #ecdff5;
  border-top: 1px solid #dfdfdf;
}
.tab-item {
  width: 33%;
  flex-grow: 1;
  border-right: 1px solid #d7d7d7;
  height: 25px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #999;
  cursor: pointer;
}
.tab-item:last-of-type {
  border-right: none;
}
.active {
  font-weight: 600;
  color: #333;
}
.dialig-tips {
  font-size: 12px;
  color: #fff;
  margin-bottom: 10px;
}
.dialig-tips b {
  color: red;
  font-size: 18px;
  margin: 0 5px;
  vertical-align: middle;
  line-height: 0;
}
</style>
